import { render, staticRenderFns } from "./FigureModal.vue?vue&type=template&id=128b18fb"
import script from "./FigureModal.vue?vue&type=script&lang=ts"
export * from "./FigureModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports